<style lang="less">
@import '../../stylesheet/variable.less';
.none-order {
  img {
    width: 95px;
    height: 95px;
    margin-bottom: 10px;
  }
  .no-text {
    color: @lightSliver;
    font-size: 14px;
  }
  .refresh {
    font-size: 14px;
    width: 150px;
    align-items: center;
    margin: 20px auto 0;
    height: 33px;
    line-height: 33px;
    position: relative;
    color: #2E2F30;
    &::after {
      .setBorderLine(rgb(121, 125, 130))
    }
  }
  background: #fff;
  height: 100vh;
  z-index: 9;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  // align-items: center;
  padding-top: 189px;
}
</style>

<template>
  <div class="none-order" :class="myClass">
    <div style="text-align: center">
      <img :src="imgUrl">
      <div class="no-text">{{text}}</div>
      <div class="refresh" @click="refresh" v-if="showRefreshBtn">重新加载</div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
import defaultImgUrl from '../../image/order/rectangleCopy20@2x.png'
export default {
  props: {
    myClass: String,
    text: {
      type: String,
      default: '网络异常，请检查网络或重新加载'
    },
    imgUrl: {
      type: String,
      default: defaultImgUrl
    },
    allReload: {
      type: Boolean,
      default: false
    },
    showRefreshBtn: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: "100vh"
    }
  },
  methods: {
    refresh() {
      if(this.allReload)  {
        return window.location.reload()
      }
      this.$emit("refresh")
    }
  }
}
</script>

